import { Box, Flex, FormLabel, Select, Spinner, Text, useMediaQuery } from '@chakra-ui/react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { Table, Tbody, Td, Thead, Tr } from '../../components/Table';
import { List } from './List';
import { Columns } from './Columns';
import { Filtro } from './Filtro';
import { user } from '../../helpers/user';
import { useNavigate } from 'react-router-dom';
import { useVendedoresMensal } from '../../hooks/useVendedoresMensal';
import { Pagination } from '../../components/Pagination';
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta';

export function Pedidos() {
  const { idVendedor } = useParams();
  const history = useNavigate();
  //maxW 1366px
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)');

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { customers } = useVendedoresMensal();

  const [searchParams, setSearchParams] = useSearchParams();

  const [orderByT, setOrderByT] = useState({ column: null, direction: 'asc' });

  function orderByDate(column, direction) {
    const sortedData = [...data].sort((a, b) => {
      let valueA = new Date(a[column]);
      let valueB = new Date(b[column]);

      return direction === 'asc' ? valueA - valueB : valueB - valueA;
    });

    setData(sortedData);
  }

  function orderBy(column, type) {
    const direction = orderByT.column === column && orderByT.direction === 'asc' ? 'desc' : 'asc';
    setOrderByT({ column, direction });

    if (type === 'date') {
      return orderByDate(column, direction);
    }

    const sortedData = [...data].sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      if (!isNaN(valueA) && !isNaN(valueB)) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      }

      return direction === 'asc' ? valueA - valueB : valueB - valueA;
    });

    setData(sortedData);
  }

  const [page, setPage] = useState(
    searchParams.get('page') ? parseInt(searchParams.get('page')) : 1
  );
  const [meta, setMeta] = useState(null);

  const startItem = (page - 1) * 10 + 1;
  const endItem = page * 10 > data?.length ? data?.length : page * 10;

  function handleSearchParams(params) {
    //guarda os parametros que ja estavam na url e adiciona os novos
    const newParams = new URLSearchParams(searchParams);

    setSearchParams({
      ...Object.fromEntries(newParams),
      ...params
    });
  }

  function handleLimit(limit) {
    if (loading) return;

    handleSearchParams({ limit: limit });
  }

  function handlePage(page) {
    if (loading) return;
    setPage(page);

    handleSearchParams({ page: page });
  }

  console.log(meta);

  return (
    <Box bgColor="white" minH="100vh" w="full">
      <Flex
        w="full"
        alignItems="center"
        gap={2}
        position="relative"
        justifyContent="center"
        maxWidth="1600px"
        mx="auto"
        {...(isLargerThan1366 && { maxWidth: '1309px' })}>
        {permissoesUsuariosPropostas[user.codigo_usuario] && (
          <Select
            ml={2}
            onChange={(e) => history(`/pedidos-vendedor/${e.target.value}?${searchParams}`)}
            maxW="347px"
            w="full"
            minH="51px"
            value={idVendedor}
            borderRadius="0"
            m="0">
            <option value="">Selecione um vendedor</option>
            <option value="0">Todos</option>
            {customers?.map((customer) => (
              <option key={customer.codigo_usuario} value={customer.codigo_usuario}>
                {customer.apelido}
              </option>
            ))}
          </Select>
        )}
        <Box
          paddingBlock="14px"
          bg={'#378BBF'}
          textAlign="center"
          fontSize="16px"
          color="white"
          fontWeight="bold"
          w="full">
          <Text mr={user?.codigo_usuario === 30 && '420px'}>Pedidos: {meta?.totalItens}</Text>
        </Box>
      </Flex>

      <Flex
        mt="10px"
        flexDirection="column"
        justifyContent="center"
        maxWidth="1600px"
        {...(isLargerThan1366 && { maxWidth: '1309px' })}
        mx="auto">
        <Filtro setMeta={setMeta} setData={setData} setLoading={setLoading} />
        <Table mt={4} borderCollapse="collapse" variant="outline">
          <Thead>
            <Columns orderBy={orderBy} ordered={orderByT} />
          </Thead>
          <Tbody>
            {!loading && <List data={data} />}
            {loading && (
              <Tr>
                <Td colSpan={15}>
                  <Spinner />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>

        {!loading && data.length === 0 && (
          <Text textAlign="center" fontSize="sm" mt={4} fontWeight="semibold" color="gray.500">
            Nenhuma proposta encontrada
          </Text>
        )}
        <Box
          mt={2}
          mr="auto"
          display={data?.length !== 0 ? 'flex' : 'none'}
          justifyContent="center"
          alignItems="center"
          gap={2}
          mb={5}>
          <Text fontSize="xs" color="gray.500" textAlign="center">
            {startItem} - {endItem} de {meta?.totalItens} propostas
          </Text>
          <Pagination
            page={page}
            setPage={handlePage}
            totalPages={meta?.totalPages}
            isDisabled={loading}
          />
          <Flex alignItems="center" gap={1}>
            <FormLabel htmlFor="limit" fontSize="xs" color="gray.500" m={0}>
              Itens por página:
            </FormLabel>
            <Select
              id="limit"
              w="100px"
              onChange={(e) => handleLimit(e.target.value)}
              size="sm"
              disabled={loading}>
              <option selected value="">
                Selecione
              </option>
              {Array.from({ length: Math.ceil(meta?.totalItens / 100) }, (_, index) => (
                <option key={index} value={(index + 1) * 30}>
                  {(index + 1) * 30 <= meta?.totalItens
                    ? `${(index + 1) * 30} itens`
                    : `Até ${meta?.totalItens} itens`}
                </option>
              ))}
              <option value={meta?.totalItens}>Mostrar tudo</option>
            </Select>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}
